import { useQuery } from '../lib/queryClient';

export interface BrandingConfig {
  logoUrl: string;
  faviconUrl: string;
  brandName: string;
  primaryColor: string;
  customCss: string | null;
  themeTokens: string | null;
  themeMode: string | null;
  source: 'default' | 'partner' | 'tenant';
}

const DEFAULT_BRANDING: BrandingConfig = {
  logoUrl: '/logo.png',
  faviconUrl: '/favicon.png',
  brandName: 'tasking.tech',
  primaryColor: '#6366f1',
  customCss: null,
  themeTokens: null,
  themeMode: null,
  source: 'default',
};

export const BRANDING_QUERY_KEY = ['branding'];

async function fetchBranding(): Promise<BrandingConfig> {
  try {
    const res = await fetch('/_api/tenants/branding', { credentials: 'include' });
    if (!res.ok) return DEFAULT_BRANDING;
    const data = await res.json();
    return data.branding || DEFAULT_BRANDING;
  } catch {
    return DEFAULT_BRANDING;
  }
}

export function useBranding() {
  const { data: branding, isLoading } = useQuery({
    queryKey: BRANDING_QUERY_KEY,
    queryFn: fetchBranding,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });

  return {
    branding: branding || DEFAULT_BRANDING,
    isLoading,
    isWhiteLabeled: branding ? branding.source !== 'default' : false,
  };
}
